import { render, staticRenderFns } from "./OrderProcess.vue?vue&type=template&id=154c19d1"
import script from "./OrderProcess.vue?vue&type=script&lang=js"
export * from "./OrderProcess.vue?vue&type=script&lang=js"
import style0 from "./OrderProcess.vue?vue&type=style&index=0&id=154c19d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports